import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Box, TextField, Button, Typography, Alert, InputAdornment, CircularProgress } from '@mui/material';
import { Email, Lock, CheckCircle, Cancel } from '@mui/icons-material';
import api from '../../api/axiosInstance';

export const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <Box sx={{ textAlign: "center" }}>
        <Box sx={{ fontSize: 48, mb: 2 }}>📬</Box>
        <Typography variant="h4" fontWeight={700} mb={1.5}>Reset link sent</Typography>
        <Typography color="text.secondary" mb={3}>
          If <strong>{email}</strong> is registered, you'll receive a password reset link shortly.
        </Typography>
        <Button variant="outlined" component={Link} to="/login" fullWidth>Back to Login</Button>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h3" fontWeight={700} >Forgot password?</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Enter your email and we'll send you a reset link.
      </Typography>

      {error && <Alert severity="error" sx={{ mb: 3, borderRadius: 2 }}>{error}</Alert>}

      <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <TextField
          label="Email address"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          autoFocus
          slotProps={{
            input: {
              startAdornment: <InputAdornment position="start"><Email sx={{ fontSize: 18, color: 'text.disabled' }} /></InputAdornment>,
            },
          }}
        />
        <Button type="submit" variant="contained" size="large" fullWidth disabled={loading} sx={{ py: 1.375 }}>
          {loading ? <CircularProgress size={20} sx={{ color: 'white' }} /> : 'Send Reset Link'}
        </Button>
      </Box>

      <Typography variant="body2" color="text.secondary" textAlign="center" mt={3}>
        <Typography component={Link} to="/login" sx={{ color: 'primary.main', fontWeight: 600, textDecoration: 'none' }}>
          ← Back to login
        </Typography>
      </Typography>
    </Box>
  );
};



export default ForgotPasswordPage;